export default __webpack_public_path__ + "static/media/HeartImage.c4d55b3d.svg";